import { render, staticRenderFns } from "./CourseVideoPlaceholder.vue?vue&type=template&id=da8cf88e"
import script from "./CourseVideoPlaceholder.vue?vue&type=script&lang=js"
export * from "./CourseVideoPlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports